import BigNumber from 'bignumber.js';
import { DECIMAL_6, RESULT_BIG, RESULT_SAME, RESULT_SMALL } from '@/types';
import { cutCommas } from './util';

const ROUND = BigNumber.ROUND_DOWN;

/**
 * 두 수 더하기
 * @param aNum1 // 첫 번째 수
 * @param aNum2 // 두 번째 수
 * @param aDecimal // 표시할 소수점 자리수 (기본 6자리)
 * @returns // 결과 값
 */
export const addNum = (aNum1: string | number, aNum2: string | number = '0', aDecimal: number = DECIMAL_6): string => {
  return BigNumber(aNum1).plus(aNum2).toFixed(aDecimal, ROUND);
};
/**
 * 두 수 빼기
 * @param aNum1 // 첫 번째 수
 * @param aNum2 // 두 번째 수
 * @param aDecimal // 표시할 소수점 자리수 (기본 6자리)
 */
export const minusNum = (aNum1: string | number, aNum2: string | number, aDecimal: number = DECIMAL_6): string => {
  return BigNumber(aNum1).minus(aNum2).toFixed(aDecimal, ROUND);
};

export const dividedNum = (aNum1: string | number, aNum2: string | number, aDecimal: number = DECIMAL_6): string => {
  return BigNumber(aNum1).dividedBy(aNum2).toFixed(aDecimal);
};
export const NumWithComma = (aNum: string) => {
  const parts = aNum.split('.');
  // 정수 부분에만 천 단위 구분 기호(콤마) 적용
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 정수와 소수 부분을 다시 합침
  return parts.join('.');
};
/**
 * 두 수 비교, 앞 숫자(aNum1) 기준
 * @param aNum1
 * @param aNum2
 * @returns RESULT_SMALL:작다, RESULT_SAME:같다 RESULT_BIG:크다
 */
export const compareNum = (aNum1: string | number, aNum2: string | number) => {
  let result;
  if (BigNumber(aNum1).gt(aNum2)) {
    result = RESULT_BIG; // 크다
  } else if (BigNumber(aNum1).lt(aNum2)) {
    result = RESULT_SMALL; // 작다
  } else {
    result = RESULT_SAME; // 같다.
  }
  return result;
};
/**
 * 비교값을 넣어 최소, 최대에 포함되는지 여부
 * @param aAmt 비교 값
 * @param aMax 최대 값
 * @param aMin 최소 값
 * @returns ture 포함, false: 범위 초과
 */
export const isIncludeInMaxAndMin = (aAmt: string, aMax: string, aMin: string): boolean => {
  let result = true;

  if (isNegative(aAmt) || isNegative(aMax) || isNegative(aMin)) {
    return false;
  }

  const maxZero = BigNumber(aMax);
  if (
    (!maxZero.isZero() && RESULT_BIG === compareNum(aAmt, String(aMax))) ||
    RESULT_SMALL === compareNum(aAmt, String(aMin))
  ) {
    result = false;
  }

  return result;
};

/**
 * 음수인지 체크
 * @param aAmt 비교 값
 * @returns 음수: true, 양수: false, 0: false
 */
export const isNegative = (aAmt: string | number): boolean => {
  const num = BigNumber(aAmt);
  return num.isNegative();
};

export const isZero = (aAmt: string | number): boolean => {
  const num = BigNumber(aAmt);
  return num.isZero();
};

/** */
export const fiexdDecimal = (aAmount: string | number, aDecimal: number = 2, aFixed = ROUND) => {
  const re = isNaN(Number(aAmount))
    ? '0'
    : BigNumber(aAmount).isZero()
    ? '0'
    : BigNumber(aAmount).toFixed(aDecimal, aFixed);
  return re;
};
// 함수 정의: 소수점 0 절사
export const trimTrailingZeros = (value: string): string => {
  return value.replace(/(\.[0-9]*[1-9])0+$|\.0*$/, '$1');
};

/**
 * hex to utf 변환
 * @param aValue hex string
 * @returns
 */
export const hexToUtf = (aValue: string): string => {
  const re = BigNumber(aValue, 16).toFixed(0);
  return re;
};

export const packBigNumbers = (value: string) => {
  const val = cutCommas(value); // 콤마가 있을 경우 계산할 때 NaN 발생
  return trimTrailingZeros(NumWithComma(fiexdDecimal(val)));
};
